<div
  class="long-time-loader non-blocking"
  [hidden]="!creatingWorkspace && !addingWorkspaceDocuments"
>
  <div class="status-text">
    <div class="spinner-border" role="status"></div>
    <div class="info-text">
      <b> {{ 'text.addingDocuments' | transloco }}</b>
      {{ 'text.addingDocumentInProgress' | transloco }}
    </div>
  </div>
</div>
